// extracted by mini-css-extract-plugin
export default {"deleteIcon":"IdentityInfo_deleteIcon__1GP7D"};